module.exports = __webpack_public_path__ + "static/attract-customers-49154e3ab66cb7fd2bcb8b8d0f16a9a2.svg";